<template>
  <div class="home">
    <h2>From the lines, emerges texture and form.</h2>
    <img src="https://malikblackman.com/images/2.png"/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeView',
  components: {
  }
})
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  height: 100%;
}

h2 {
  color: #774936;
}

img {
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  object-fit: cover;
}
</style>
